import { RequestsContent } from "content";
import { ERequestStatus, ERequestType } from "types/api/requests";
import { TSelectOption } from "types/app/select";

export const REQUEST_TYPE_OPTIONS: TSelectOption<ERequestType>[] = [
  {
    label: RequestsContent.Option.NOBO,
    value: ERequestType.NOBO,
  },
  {
    label: RequestsContent.Option.IELTS,
    value: ERequestType.IELTS,
  },
];

export const REQUEST_STATUS_OPTIONS: TSelectOption<ERequestStatus>[] = [
  {
    label: RequestsContent.Option.NEW,
    value: ERequestStatus.NEW,
  },
  {
    label: RequestsContent.Option.PROCESSED,
    value: ERequestStatus.PROCESSED,
  },
];
